import UAParser from 'ua-parser-js';
if (typeof window !== 'undefined' && typeof (window as any).UAParser === 'undefined') {
    (window as any).UAParser = UAParser;
}
// TODO: DELETE 
export namespace IUAParser {
    export interface IResult {
        browser: {
            name: string;
            major: string;
        }
        os: {
            name: string;
            version: string;
        }
        device: {
            model: string;
        }
    }
}

let uaInfo: IUAParser.IResult | null = null;
export const getUAInfo = () => {
    if (!uaInfo) {
        // @ts-ignore
        uaInfo = new UAParser().getResult() as IUAParser.IResult;
    }
    return uaInfo;
};

/**
 * 判断是否当前浏览器环境是否是ie8/ie9来做cors兼容
 */
export function needCompatible() {
    const uaInfo = getUAInfo();
    if (uaInfo.browser.name !== 'IE') {
        return false;
    }

    return uaInfo.browser.major && +uaInfo.browser.major <= 9;
}

// 从vue-router里面拿的……
export function supportsPushState() {
    const ua = window.navigator.userAgent;
    if (
        (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1)
        && ua.indexOf('Mobile Safari') !== -1
        && ua.indexOf('Chrome') === -1
        && ua.indexOf('Windows Phone') === -1
    ) {
        return false;
    }
    return window.history && 'pushState' in window.history;
}

export default {
    needCompatible,
    supportsPushState,
    getUAInfo
};